import { HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ConfigServerService, CustomHttp } from '../../../core';
import { AtividadeSearch, AtividadeSearchAtividade, AtividadeSearchTotal } from '../atividade-search';
import { AtividadeFilter } from '../filter';

@Injectable({
    providedIn: 'root'
})
export class AtividadeSearchHttpService {
    resource = 'atividade';
    private pathApi: string;

    constructor(configServerService: ConfigServerService,
                private customHttp: CustomHttp) {
        this.pathApi = `${configServerService.getPathApi()}/${this.resource}`;
    }

    /** pesquisa as atividades e seus totais */
    search(filter: AtividadeFilter, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<AtividadeSearch> {
        // Params
        let params = new HttpParams()
                        .append('offset', offset ? offset.toString() : null)
                        .append('limit', limit ? limit.toString() : null)
                        .append('orderBy', orderBy ? orderBy.toString() : null)
                        .append('orderByDir', orderByDir ? orderByDir : null);

        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<AtividadeSearch>(this.pathApi, {params});
    }

    /** Pesquisa as atividades */
    atividades(filter: AtividadeFilter, offset: number, limit: number, orderBy: number, orderByDir: string): Observable<AtividadeSearchAtividade[]> {
        // Params
        let params = new HttpParams()
                        .append('offset', offset.toString())
                        .append('limit', limit.toString())
                        .append('orderBy', orderBy ? orderBy.toString() : null)
                        .append('orderByDir', orderByDir ? orderByDir : null);

        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<AtividadeSearchAtividade[]>(`${this.pathApi}/0/search/atividade`, {params});
    }

    /** Obtem os totais da pesquisa as atividades */
    total(filter: AtividadeFilter): Observable<AtividadeSearchTotal> {
        // Params
        let params = new HttpParams();
        // Filter params
        if (filter) {
            params = filter.createParams(params);
        }

        return this.customHttp.get<AtividadeSearchTotal>(`${this.pathApi}/0/search/total`, {params});
    }
}
